import { useQuery } from '@tanstack/react-query';

import { voiceApi } from '@/api/services/voice.api';
import { voiceKeys } from '../query-keys';

/**
 * Numbers the signed-in agent may present as caller ID — voice-enabled
 * numbers where they are an inbound ring target. Distinct from
 * `useVoiceNumbers` (admin org-wide list for the settings pages).
 *
 * The endpoint requires VOICE_CALLS_MAKE — callers gate `enabled` so the
 * query never fires for agents without it.
 */
export function useMyNumbers(options?: { enabled?: boolean }) {
    return useQuery({
        queryKey: voiceKeys.myNumbers(),
        queryFn: voiceApi.listMyNumbers,
        staleTime: 30_000,
        enabled: options?.enabled ?? true,
    });
}
